import { Grid, IconButton, InputBase, Typography } from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { useState } from "react";

/**
 * @typedef {object} Props
 *
 * @property {string} id
 * @property {number} size
 * @property {string} label
 * @property {string} type
 * @property {boolean} required
 * @property {boolean} disabled
 * @property {string} placeholder
 * @property {React.ReactNode} endAdorement
 * @property {import("formik").UseFormikProps} formik
 *
 * @param {Props} props
 */
export default function FormInput({
  id,
  size,
  label,
  type,
  required,
  disabled,
  placeholder,
  formik,
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Grid
      item
      xs={size * 12}
      sx={{
        display: "flex",
        flexDirection: "column",
        textAlign: "start",
        gap: "8px",
      }}
    >
      <Typography
        component="label"
        fontSize={{ sm: "14px", xs: "12px" }}
        fontWeight={700}
        htmlFor={id}
        sx={{
          color: "#101928",
          fontFamily: "Satoshi",
          width: "max-content",
          textTransform: "capitalize",
        }}
      >
        {label}
      </Typography>

      <InputBase
        id={id}
        type={type === "password" && showPassword ? "text" : type}
        required={required}
        disabled={disabled}
        placeholder={placeholder}
        value={formik.values[id]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        onFocus={() => formik.setFieldTouched(id, false)}
        endAdornment={
          <div style={{ color: disabled ? "#D0D5DD" : "#667185" }}>
            {id === "email" ? (
              <EmailOutlinedIcon />
            ) : type === "password" ? (
              <IconButton
                sx={{ padding: 0 }}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <VisibilityOutlinedIcon />
                ) : (
                  <VisibilityOffOutlinedIcon />
                )}
              </IconButton>
            ) : null}
          </div>
        }
        sx={{
          boxShadow: `inset 0 0 0 1.5px ${formik.touched[id] && formik.errors[id] ? "#F04438" : "#D0D5DD"
            }`,
          borderRadius: "12px",
          fontFamily: "Satoshi",
          padding: "16px",
          fontSize: { sm: "14px", xs: "12px" },
          fontWeight: 500,
          transition: "box-shadow 0.15s ease-in-out",

          "&.Mui-focused": {
            boxShadow: "inset 0 0 0 1.5px #6552F3",
          },
        }}
      />

      <Typography
        sx={{
          color: "#F04438",
          fontSize: "12px",
          textAlign: "start",
          height: "20px",
        }}
      >
        {formik.touched[id] && formik.errors[id]}
      </Typography>
    </Grid>
  );
}
